module.exports = __webpack_public_path__ + "img/banner02.e688b014.jpg";